import { get } from "./apiClient";

export default {
  async getList() {
    return await get(`hygieneProtocol`);
  }
};
